export default "__VITE_ASSET__CDi7zyXU__"